import React, { useEffect, useState } from 'react';
import classnames from 'classnames';

import PhoneInput from '../../..//FormComponents/PhoneInput';
import './index.scss';
import utils from '../../../../lib/utils';

const BrandPersonalization = ({
    onSave,
    onCancel,
    auth,
    voiceaiconfig,
    softwares,
}) => {
    const [weavePhone, setWeavePhone] = useState(() => {
        const phones = softwares?.info?.weave_phones;
        return Array.isArray(phones) && phones[0]?.id ? phones[0].id : '';
    });
    const [weaveLocationId, setWeaveLocationId] = useState(softwares?.info?.external_id || '');
    const [loading, setLoading] = useState(true);
    // Fetch workflow on mount
    useEffect(() => {
    }, []);

    // Update workflow state when props change
    useEffect(() => {
        
    }, []);

    useEffect(() => {
        if (voiceaiconfig.updatingWeavePhone === true) {
            // Start loading
            setLoading(true);
            console.log('loading start');
        } else if (voiceaiconfig.updatingWeavePhone === false) {
            // Stop loading and update workflow
            setLoading(false);
            console.log('loading end');
        }
    }, [voiceaiconfig.updatingWeavePhone]);
    
    // Handle textarea change
    const handleChange = (e) => {
        setWeavePhone(e.target.value);
    };
    
    const handleLocationChange = (e) => {
        setWeaveLocationId(e.target.value);
    };

    // Disable save if JSON invalid
    const validateSave = () => {
        if (loading || (weaveLocationId.length > 0 && utils.isValidPhone(weavePhone))){
            return false; // valid → enable
        } else {
            return true; // invalid → disable
        }
    };
    const { updateWeavePhoneFail} = voiceaiconfig;
    return (
        <div className="design">
            <div className="workflow_config">
                <div className="form-group">
                    <label htmlFor="phone">WEAVE PHONE NUMBER</label>
                    <PhoneInput
                        placeholder=""
                        name="phone"
                        value={weavePhone}
                        onChange={handleChange}
                        className={classnames({
                            'has-error': weavePhone.length<1,
                        })}
                    />
                </div>
                <div className="form-group">
                <label htmlFor="weave_location_id">LOCATION ID</label>
                <input
                    type="text"
                    name="weave_location_id"
                    placeholder="Enter Weave Location ID"
                    value={weaveLocationId}
                    onChange={handleLocationChange}
                    className={classnames({
                        'has-error': !weaveLocationId
                    })}
                />
                </div>
                <div className="actions">
                    <button
                        type="button"
                        className="btn btn--primary btn--md first-button"
                        onClick={(e) => onSave({ 'weave_id': weaveLocationId, 'weave_phone': weavePhone })}
                        disabled={validateSave()}
                    >
                        {loading ? 'SAVING...' : 'SAVE'}
                    </button>
                </div>
                {updateWeavePhoneFail && <div className="error-message">Something went wrong, please try again later</div>}
            </div>
        </div>
    );
};

export default BrandPersonalization;
